angular.module('internal.fuellimit',[])
    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider.state('internal.fuellimit', {
            url: '/fuellimit/:prevState',
            views: {
                content: {
                    templateUrl: 'js/internal/fuel-limit/fuel-limit.view.html',
                    controller:'FuelLimitCtrl',
                    controllerAs:'vm'
                }
            }
        });
    }]);